import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import Swal from "sweetalert2";
import { PedidoService } from "src/app/core/services/pedido-service";
import { Order } from "src/app/core/entities/order";
import { ToastrService } from "ngx-toastr";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ProductService } from "src/app/core/services/product-service";
import { CurrencyPipe } from "@angular/common";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { UsuarioService } from "src/app/core/services/usuario-service";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead";
import { formatDate } from "@angular/common";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { SecurityService } from "src/app/core/services/security-service";
import { InitProvider } from "src/app/core/services/init-provider";
import { RelatorioService } from "src/app/core/services/relatorios.service";
import { DateRangeOption } from "src/app/core/interfaces/date-range";
import { DateRangeFactoryService } from "src/app/core/services/date-range-factory.service";

declare var $: any;
import "@angular/localize/init";

@Component({
  selector: "app-lista-pedido-b2c",
  templateUrl: "./lista-pedido-b2c.component.html",
  styleUrls: ["./lista-pedido-b2c.component.css"],
})
export class ListaPedidoB2cComponent implements OnInit {
  SITE: ConfiguracoesSite;
  public layout: number;
  public pedidos: Order[] = [];
  public pedido: any;
  public empty: boolean = false;
  public loading: boolean = false;
  public orderItens: any[] = [];
  public tablePedidoView
  public qrCode: any = {};
  public loadNota: boolean = false;
  public mapItens;
  public mapProdutos;
  public compactMode: boolean = false;
  // Filtros
  public formSearch: FormGroup;
  public ranges: DateRangeOption[] = [];
  public searchTerm: string = "";
  public selectedPeriod: string = "3meses";

  // Paginação
  public page = 1;
  public pageSize = 10;
  public totalPages = 0;
  public totalElements = 0;
  public first = true;
  public last = false;


  private currencyPipe: CurrencyPipe = new CurrencyPipe("pt-BR");

  constructor(
    private router: Router,
    private rangeFactory: DateRangeFactoryService,
    private route: ActivatedRoute,
    private relatorioService: RelatorioService,
    public pedidoService: PedidoService,
    public productService: ProductService,
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder,
    private localeService: BsLocaleService,
    private toastService: ToastrService,
    public initProvider: InitProvider,
    public securityService: SecurityService
  ) {
    this.layout = Configuracoes.layout;
    this.SITE = Configuracoes.SITE;
    this.localeService.use("pt-custom");

    this.formSearch = this.formBuilder.group({
      data: [[]],
      pedido: [""],
    });
    this.loadPedidos();
  }

  ngOnInit() {
    this.ranges = this.rangeFactory.getDefaultRanges();
    // this.loadPedidos();
  }

  onPedidoChange(valor: string) {
    this.formSearch.controls.pedido.setValue(valor);
  }

  clearPedido() {
    this.formSearch.controls.pedido.setValue("");
    this.loadPedidos(0);
  }

  private applyPeriodFilter(form: any) {

    const hoje = new Date();

    if (this.selectedPeriod === '3meses') {
      const inicio = new Date();
      inicio.setMonth(hoje.getMonth() - 3);

      form.dataInicial = formatDate(inicio, 'dd/MM/yyyy', 'en');
      form.dataFinal = formatDate(hoje, 'dd/MM/yyyy', 'en');
      return;
    }

    // ano específico (ex: 2026)
    const ano = Number(this.selectedPeriod);
    if (!isNaN(ano)) {
      const inicio = new Date(ano, 0, 1);
      const fim = new Date(ano, 11, 31);

      form.dataInicial = formatDate(inicio, 'dd/MM/yyyy', 'en');
      form.dataFinal = formatDate(fim, 'dd/MM/yyyy', 'en');
    }
  }

  get visiblePages(): number[] {
    const maxVisible = 5;

    if (!this.totalPages) return [];

    let start = Math.max(1, this.page - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > this.totalPages) {
      end = this.totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  loadPedidos(page: number = 1) {
    this.loading = true;

    // Validação para não carregar páginas inválidas
    if (page < 1) page = 1;
    if (page > this.totalPages && this.totalPages > 0) page = this.totalPages;

    this.page = page;

    const form: any = {
      page: page - 1,
      tipo: "TODOS",
      pedido: this.searchTerm
    };

    this.applyPeriodFilter(form);

    if (this.formSearch.value.pedido) {
      form.pedido = this.formSearch.value.pedido;
    }

    this.pedidoService.listaPedidoCliente(
      form,
      (resp) => {
        this.pedidos = resp.content || [];
        this.totalPages = resp.totalPages;
        this.totalElements = resp.totalElements;
        this.first = resp.first;
        this.last = resp.last;
        this.empty = this.pedidos.length === 0;
        this.loading = false;
      },
      () => {
        this.empty = true;
        this.loading = false;
      }
    );
  }

  // Método utilitário para gerar array de números para navegação numérica (se quiser adicionar depois)
  getPages(): number[] {
    const pages: number[] = [];
    const maxVisible = 5; // Número máximo de páginas visíveis

    let start = Math.max(1, this.page - Math.floor(maxVisible / 2));
    let end = Math.min(this.totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }



  onSearch() {
    this.loadPedidos(0);
  }

  onPeriodChange(periodo: string) {
    this.selectedPeriod = periodo;
    this.loadPedidos(0);
  }

  // Rastrear pacote
  redirectToRastreio(p: Order) {
    const rastreio = (p as any)?.freteRastreios?.length
      ? (p as any).freteRastreios[0].rastreio
      : null;

    if (rastreio) {
      window.open(rastreio, "_blank")?.focus();
    } else {
      this.toastService.warning($localize`Sem rastreio associado ao pedido`);
    }
  }

  // Ver pedido - mostrar detalhes
  showPedido(p: Order) {
    const pedidoId =
      (p as any).numero_pedido || (p as any).pedido || (p as any).id;
    this.pedidoService.pedidoCliente(pedidoId, (e) => {
      this.pedido = { ...e, infos: p.infos };
      $("#pedidoModalB2C").modal("show");
    });
  }

  // Nota fiscal - abrir formulário com documentos
  showNotaFiscal(p: Order) {
    this.pedido = p;
    // this.loadNota = true;

    // Chamar endpoint listaPedidoCliente para obter documentos
    // const form: any = {
    //   page: 0,
    //   pedido: p.numero_pedido || p.id,
    // };

    // this.pedidoService.listaPedidoCliente(
    //   form,
    //   (resp) => {
    //     if (resp.content && resp.content.length > 0) {
    //       const pedidoCompleto = resp.content[0];
    //       this.pedido.documentos = pedidoCompleto.documentos || [];
    //     }
    //     this.loadNota = false;
    //     $("#notaFiscalModal").modal("show");
    //   },
    //   () => {
    //     this.loadNota = false;
    //     this.toastService.error("Erro ao carregar nota fiscal", "Erro");
    //   }
    // );
  }

  // Download/Visualizar documento
  printNota(nota: any) {
    if (!nota || !nota.id) return;

    const headers = new Headers({
      Branch: Configuracoes.API_BRANCH,
      Authorization: "Bearer " + window.localStorage.getItem("token"),
    });

    if (nota.tipo === "danfe") {
      this.loadNota = true;
      fetch(
        `${Configuracoes.API}impressoes/documento?id_documento=${nota.id}`,
        {
          method: "GET",
          headers,
        }
      )
        .then((response) => response.text())
        .then((jsonResposta) => {
          this.relatorioService.getDanfePdf(
            jsonResposta,
            (pdf) => {
              window.open(pdf.arquivo);
              this.loadNota = false;
            },
            (erro) => {
              console.error("Erro ao gerar PDF", erro);
              this.loadNota = false;
            }
          );
        })
        .catch((err) => {
          console.error("Erro ao buscar XML", err);
          this.loadNota = false;
        });
      return;
    }

    this.loadNota = true;
    fetch(`${Configuracoes.API}impressoes/documento?id_documento=${nota.id}`, {
      method: "GET",
      headers,
    })
      .then((response) => response.text())
      .then((xml) => {
        const blob = new Blob([xml], { type: "application/xml" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `${nota.numero_nota}.xml`;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        this.loadNota = false;
      })
      .catch((err) => {
        console.error("Erro ao buscar XML", err);
        this.loadNota = false;
      });
  }

  // Gerar link de pagamento
  gerarLinkPagamento(p: Order) {
    const pedidoCliente =
      (p as any).pedido || (p as any).numero_pedido || (p as any).id;
    this.usuarioService.consultaPix(
      {
        pedido_cliente: pedidoCliente,
      },
      (resp) => {

        this.qrCode = resp;
        $("#pixModal").modal("show");
      },
      (resp) => {
        console.log(resp)
  ;
        this.toastService.info(resp.error.detail, "Pix", {
          timeOut: 4000,
        });
      }
    );
  }

  copyLink(link: string) {
    if (!link) return;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        this.toastService.success(
          $localize`Link copiado com sucesso para a área de transferência$localize`,
          $localize`Pagamento$localize`,
          {
            positionClass: "toast-bottom-left",
          }
        );
      })
      .catch(() => {
        this.toastService.warning(
          $localize`Erro ao copiar link para a área de transferência`,
          $localize`Pagamento$localize`,
          {
            positionClass: "toast-bottom-left",
          }
        );
      });
  }

  // Formatar data
  formatData(data: string): string {
    if (!data) return "";
    const parts = data.split("/");
    if (parts.length === 3) {
      return `${parts[0]} de ${this.getMesNome(parseInt(parts[1]))} de ${parts[2]
        }`;
    }
    return data;
  }

  getMesNome(mes: number): string {
    const meses = [
      "janeiro",
      "fevereiro",
      "março",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro",
    ];
    return meses[mes - 1] || "";
  }

  // Formatar valor
  formatValor(valor: number): string {
    return (
      this.currencyPipe.transform(valor, "BRL", "symbol", "1.2-2") || "R$ 0,00"
    );
  }

  // Obter nome do cliente
  getClienteNome(p: Order): string {
    if (p.clientes && p.clientes.length > 0) {
      return p.clientes[0].cliente?.nome || "";
    }
    return p.cliente?.nome || "";
  }

  // Obter status do pedido
  getStatusPedido(p: Order): string {
    if (p.infos && p.infos.length > 0) {
      return p.infos[p.infos.length - 1].statusDescricao || "Processando";
    }
    return "Processando";
  }

  // Obter produtos do pedido
  getProdutos(p: Order): string[] {
    const produtos: string[] = [];
    if (p.itens && p.itens.length > 0) {
      p.itens.forEach((item: any) => {
        produtos.push(item.descricao || item.produtoDescricao || "Produto");
      });
    }
    return produtos;
  }

  showPedidoFinalizado(p: any) {
    this.pedido = p;
    this.orderItens = p.itens;
    this.mapaItensEProdutos();
    this.tablePedidoView = "";
    this.agruparPorProdutoReferencia(this.orderItens)
  }

  mapaItensEProdutos() {
    this.mapItens = {};
    this.pedido.itens.forEach((i) => {
      if (this.mapItens[i.produto]) {
        this.mapItens[i.produto].push(i);
      } else {
        this.mapItens[i.produto] = [i];
      }
    });
    this.mapProdutos = {};
    this.pedido.itens.forEach((i) => {
      this.mapProdutos[i["produto"] as any] = null;
    });
  }

  agruparPorProdutoReferencia(data) {
    const agrupado: Record<string, any[]> = {};
    data.forEach((item) => {
      // Usa produtoDescricao, mas se não existir, usa descricao
      const descricao =
        item.produtoDescricao || item.descricao || "Sem descrição";

      if (!agrupado[descricao]) {
        agrupado[descricao] = [];
      }

      agrupado[descricao].push(item);
    });

    this.orderItens = Object.keys(agrupado).map((key) => ({
      produtoReferencia: agrupado[key][0]?.produtoReferencia || "",
      produtoDescricao: key,
      itens: agrupado[key],
    }));
  }
}
